/**
 * Represents an item that is used in the DeskScene
 * This includes school supplies such as pencils and books, garbage like a wad of paper, a spill, and a sponge to clean the spill
 */
export class DeskItem {
    public id: number;
    public name: string;
    public quantity: number;
    public display_width: number;
    public display_height: number;
    public angle: number;
    public startX?: number;
    public startY?: number;

    public static SUPPLIES: DeskItem[] = [
        { id: 0, name: "pencil", quantity: 2, display_width: 13, display_height: 90, angle: -10 },
        { id: 1, name: "pen", quantity: 2, display_width: 20, display_height: 90, angle: 10 },
        { id: 2, name: "book", quantity: 1, display_width: 80, display_height: 100, angle: 10 },
        { id: 3, name: "notebook", quantity: 2, display_width: 90, display_height: 100, angle: -10 },
        { id: 4, name: "eraser", quantity: 1, display_width: 25, display_height: 35, angle: 20 },
    ];

    public static GARBAGE_ITEMS: DeskItem[] = [
        { id: 5, name: "plane", quantity: 1, display_width: 120, display_height: 70, angle: 0 },
        { id: 6, name: "paper_wad", quantity: 2, display_width: 60, display_height: 60, angle: 0 },
    ];

    public static SPILL: DeskItem = { id: 7, name: "spill", quantity: 1, display_width: 90, display_height: 40, angle: 0 };

    public static CLEANING_ITEM: DeskItem = { id: 8, name: "sponge", quantity: 1, display_width: 40, display_height: 60, angle: 10 };

    public static ALL_ITEMS: DeskItem[] = DeskItem.SUPPLIES.concat(DeskItem.GARBAGE_ITEMS);
}



// WEBPACK FOOTER //
// ./src/games/OrganizeDeskGame/objects/DeskItem.ts